export default __webpack_public_path__ + "static/media/070_boost.fbab633b.mp4";